import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ruRU } from '@mui/x-date-pickers/locales';
import 'dayjs/locale/ru';
import dayjs, { Dayjs } from 'dayjs';
import { PickerChangeHandlerContext, DateValidationError } from '@mui/x-date-pickers';
import TmCalendar from '../../icons/TmCalendar';


interface DatePickerLocalizedProps {
    label: string;
    name: string;
    value: Date | string | null;
    onChange: (newValue: Date | string | null, name: string) => void;
    style?: React.CSSProperties;
}

interface InlineDatePickerProps {
    value: string | null | undefined;
    onChange: (newValue: string | null) => void;
    style?: React.CSSProperties;
}

const DatePickerLocalized: React.FC<DatePickerLocalizedProps> = ({ label, name, value, onChange, style }) => {
    const [pickerValue, setPickerValue] = React.useState<Dayjs | null>(value ? dayjs(value) : null);

    React.useEffect(() => {
        setPickerValue(value ? dayjs(value) : null);
    }, [value]);

    function handleChanged(v: Dayjs | null, context: PickerChangeHandlerContext<DateValidationError>): void {
        if (v) {
            setPickerValue(v);
            v = v.add(3, 'hour');
            const dt = v.toDate();
            onChange(dt, name)
        }
    }

    return (
        <LocalizationProvider
            localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}
            dateAdapter={AdapterDayjs}
            adapterLocale="ru"
        >
            <DatePicker
                label={label}
                name={name}
                value={pickerValue}
                onChange={handleChanged}
                slots={{
                    openPickerIcon: TmCalendar,
                }}
                slotProps={{
                    textField: {
                        size: 'small',
                        style: { ...style },
                    }
                }}
            />
        </LocalizationProvider>
    );
};

export const InlineDatePicker: React.FC<InlineDatePickerProps> = ({ value, onChange, style }) => {
    return (
        <LocalizationProvider
            localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}
            dateAdapter={AdapterDayjs}
            adapterLocale="ru"
        >
            <DatePicker
                value={value ? dayjs(value) : null}
                slots={{
                    openPickerIcon: TmCalendar,
                }}
                onChange={(newValue) => {
                    if (newValue?.isValid()) {
                        onChange(newValue ? newValue.format('YYYY-MM-DD') : null);
                    }
                }}
                slotProps={{
                    textField: {
                        size: 'small',
                        style: { ...style },
                    },
                }}
            />
        </LocalizationProvider>
    );
};

export default DatePickerLocalized;
